import { defineElement, FC, onDidLoad, useElement, useElements, useListen } from '@atomify/hooks';
import { MediaOverlayInterface } from '@molecules/media-overlay/media-overlay';

const HOUSE_HERO_GALLERY_CLICKABLE_IMAGE_JS_HOOK = '[js-hook-house-hero-gallery-clickable-image]';
const HOUSE_HERO_GALLERY_CTA_OPEN_IMAGES_JS_HOOK = '[js-hook-house-hero-gallery-cta-open-images]';
const HOUSE_HERO_GALLERY_CTA_OPEN_VR_JS_HOOK = '[js-hook-house-hero-gallery-cta-open-vr]';
const HOUSE_HERO_GALLERY_CTA_OPEN_VIDEO_JS_HOOK = '[js-hook-house-hero-gallery-cta-open-video]';
const HOUSE_HERO_GALLERY_OVERLAY_JS_HOOK = '[js-hook-house-hero-gallery-overlay]';

const HouseHeroGallery: FC = () => {
    const galleryOverlay = useElement<MediaOverlayInterface>(HOUSE_HERO_GALLERY_OVERLAY_JS_HOOK);

    const openImagesCta = useElement<HTMLButtonElement>(HOUSE_HERO_GALLERY_CTA_OPEN_IMAGES_JS_HOOK);
    const openVrCta = useElement<HTMLButtonElement>(HOUSE_HERO_GALLERY_CTA_OPEN_VR_JS_HOOK);
    const openVideoCta = useElement<HTMLButtonElement>(HOUSE_HERO_GALLERY_CTA_OPEN_VIDEO_JS_HOOK);

    const clickableImageButtons = useElements<HTMLButtonElement[]>(
        HOUSE_HERO_GALLERY_CLICKABLE_IMAGE_JS_HOOK,
    );

    const openImages = (index?: number) => galleryOverlay.current?.open({ index });
    const openVr = () => galleryOverlay.current?.open({ vr: true });
    const openVideo = () => galleryOverlay.current?.open({ video: true });

    useListen(openImagesCta, 'click', () => openImages());
    useListen(openVrCta, 'click', () => openVr());
    useListen(openVideoCta, 'click', () => openVideo());

    onDidLoad(() => {
        clickableImageButtons.current?.forEach((image: HTMLButtonElement | null, index: number) =>
            image?.addEventListener('click', () => openImages(index)),
        );
    });
};

defineElement('house-hero-gallery', HouseHeroGallery);
